var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3682 14.7155C13.0953 13.638 11.5234 11.3225 11.5234 8.63992C11.5234 4.92857 14.5321 1.91992 18.2434 1.91992C21.9548 1.91992 24.9634 4.92857 24.9634 8.63992C24.9634 11.3225 23.3916 13.638 21.1186 14.7155",
    stroke: "#0645FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0938 15.3599C26.7929 13.6281 27.8432 11.2578 27.8432 8.63992C27.8432 6.022 26.7929 3.65176 25.0938 1.91992",
    stroke: "#0645FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3616 23.9998C15.3616 22.409 14.0723 21.1198 12.4816 21.1198C10.8908 21.1198 9.60156 22.409 9.60156 23.9998V30.7198C9.60156 38.6724 16.0489 45.1198 24.0016 45.1198C31.9542 45.1198 38.4016 38.6724 38.4016 30.7198V23.9998C38.4016 22.409 37.1123 21.1198 35.5216 21.1198C33.9308 21.1198 32.6416 22.409 32.6416 23.9998V22.0798C32.6416 20.489 31.3523 19.1998 29.7616 19.1998C28.1708 19.1998 26.8816 20.489 26.8816 22.0798V20.1598C26.8816 18.569 25.5923 17.2798 24.0016 17.2798C22.4108 17.2798 21.1216 18.569 21.1216 20.1598V8.63977C21.1216 7.04905 19.8323 5.75977 18.2416 5.75977C16.6508 5.75977 15.3616 7.04905 15.3616 8.63977V29.7598V23.9998Z",
    stroke: "#353535",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3901 1.91992C9.69086 3.65176 8.64062 6.022 8.64062 8.63992C8.64062 11.2578 9.69086 13.6281 11.3901 15.3599",
    stroke: "#0645FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF3);
export default __webpack_public_path__ + "adreel-static/media/f3.a62ab4b828d93aa81ea38f4570bdad9c.svg";
export { ForwardRef as ReactComponent };